import { Text } from '@yes.technology/react-toolkit'
import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  align-items: center;
  padding: 0 16px;
  margin: 46px auto 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding: 0;
    width: 632px;
    margin: 56px auto 0;

    > button {
      width: 410px;
    }
  }
`

export const CenteredText = styled(Text)`
  text-align: center;
`
